import React, { useEffect, Fragment, useState } from "react";
import { Helmet } from "react-helmet";

import { useNavigate, useLocation, Navigate } from "react-router";
import {
  ForgetPass,
  verifyCodeNewPassword,
  ResendVerifyCode,
} from "./Components/Services";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fancyTimeFormat } from "../../Common/Function";

const ForgetPassword = ({ isModal, setShowModalLogin }) => {
  const { user_type } = useSelector(state => state);
  const location = useLocation();
  const initialState = {
    loading: false,
    data: {
      mobile: location && location.state && location.state.mobile,
    },
  };
  const [timecode, setTimecode] = useState(120);

  const navigate = useNavigate();
  // const ForgetPasswordHandler = mobile => {
  //   setState({ ...state, loading: true });
  //   ForgetPass(mobile).then(result => {
  //     setState({ ...state, loading: false });
  //   });
  // };
  const resendForgetPassword = mobile => {
    setState({ ...state, forgetPass: true });
    ResendVerifyCode(mobile).then(result => {
      setState({ ...state, forgetPass: false });
    });
  };
  const ForgetPasswordHandlerSend = (mobile, verifycode, newpassword) => {
    setState({ ...state, loading: true });
    verifyCodeNewPassword(mobile, newpassword, verifycode).then(result => {
      setState({ ...state, loading: false });
      if (typeof result === "object") {
        localStorage.removeItem("user");
        dispatch({
          local_storage: {
            key: "user",
            value: result,
          },
          type: "SET",
          payload: { user: result },
        });
        dispatch({
          local_storage: {
            key: "user_type",
            value: result.role,
          },
          type: "SET",
          payload: { user_type: result.role },
        });
        if (!isModal) {
          navigate("/User/Dashboard");
        }
        else {
          setShowModalLogin(false);
        }

      }
    });
  };
  const SetTimeOut = () => {
    setTimeout(() => {
      if (timecode >= 1) {
        setTimecode(timecode - 1);
      }
    }, 1000);
  };
  SetTimeOut();

  // useEffect(() => {
  //   ForgetPasswordHandler(location && location.state && location.state.mobile);
  // }, []);

  const dispatch = useDispatch();
  const [state, setState] = useState(initialState);

  if (user_type) {
    return <Navigate to={"/User/Dashboard"} />
  }

  return (
    <Fragment>
      {!isModal &&
        <Helmet>
          <title>نیکوتن | فراموشی کلمه عبور</title>
        </Helmet>
      }
      <div className={"main-login d-flex justify-content-center align-items-center " + (!isModal && "py-4 ")
        + (window.screen.width > 575 ? !isModal && "my-5" : "my-0")}>
        <div className="container-fluid px-3 px-md-5 d-n">
          <div className="row justify-content-center">
            <div
              className={"rounded-11 login " + (!isModal && "part-padding")}
              style={{
                boxShadow: !isModal && "rgba(0, 0, 0, 0.12) 0px 0px 3px, rgba(0, 0, 0, 0.24) 0px 0px 5px",
                width: !isModal && "450px"
              }}>
              <div className="center">
                <div className="top mb-5 d-flex flex-column align-items-center justify-content-center">
                  <Link to={"/"}>
                    <img
                      style={{ width: window.screen.width > 575 ? "150px" : "100px" }}
                      className="img"
                      src={window.origin + "/WebSide/assets/images/logo.png"}
                      alt="nikotan | نیکوتن"
                    />
                  </Link>
                  <p>نیکوتن</p>
                  <p>سامانه رزررو آنلاین ورزشی</p>
                  <p>فراموشی رمز عبور</p>
                </div>
                <div className="form-group login-form-group mb-3 mx-auto">
                  {location.state && location.state.mobile ? (
                    <p>
                      به شماره موبایل
                      <span className="text-danger mx-2">
                        {location && location.state && location.state.mobile}
                      </span>
                      کد تایید ارسال شد
                    </p>
                  ) : (
                    ""
                  )}

                  <p
                    className="h6 my-2"
                    style={{
                      fontSize: "13px",
                    }}
                  >
                    شماره موبایل شما
                  </p>
                  <div className="inputt-group d-flex">
                    <input
                      className="form-control"
                      type="text"
                      dir="ltr"
                      value={state.data.mobile}
                      disabled={
                        location && location.state && location.state.mobile
                      }
                      onChange={e => {
                        setState({
                          ...state,
                          data: { ...state.data, mobile: e.target.value },
                        });
                      }}
                      onKeyDown={e => {
                        if (e.key == "Enter") {
                          ForgetPasswordHandlerSend(
                            state.data.mobile,
                            state.data.newpassword
                          );
                        }
                      }}
                      placeholder=""
                    />
                  </div>
                  <p
                    className="h6 my-2"
                    style={{
                      fontSize: "13px",
                    }}
                  >
                    کد تایید را وارد کنید
                  </p>
                  <div className="inputt-group d-flex">
                    <input
                      className="form-control"
                      type="text"
                      dir="ltr"
                      value={state.data.verifycode}
                      onChange={e => {
                        setState({
                          ...state,
                          data: { ...state.data, verifycode: e.target.value },
                        });
                      }}
                      onKeyDown={e => {
                        if (e.key == "Enter") {
                          ForgetPasswordHandlerSend(
                            state.data.mobile,
                            state.data.verifycode,
                            state.data.newpassword
                          );
                        }
                      }}
                      placeholder=""
                    />
                  </div>
                  <p
                    className="h6 my-2"
                    style={{
                      fontSize: "13px",
                    }}
                  >
                    رمز عبور جدید خود را وارد کنید
                  </p>
                  <div className="inputt-group d-flex">
                    <input
                      className="form-control"
                      type="text"
                      dir="ltr"
                      value={state.data.newpassword}
                      onChange={e => {
                        setState({
                          ...state,
                          data: { ...state.data, newpassword: e.target.value },
                        });
                      }}
                      onKeyDown={e => {
                        if (e.key == "Enter") {
                          ForgetPasswordHandlerSend(
                            state.data.mobile,
                            state.data.verifycode,
                            state.data.newpassword
                          );
                        }
                      }}
                      placeholder=""
                    />
                  </div>
                </div>
                <button
                  onClick={() =>
                    ForgetPasswordHandlerSend(
                      state.data.mobile,
                      state.data.verifycode,
                      state.data.newpassword
                    )
                  }
                  className={`btn btn-red-v2 w-100 h6 mb-3 text-white ${state.loading ? "disabled" : null} `} >

                  {state.loading ? "در حال پردازش..." : "ثبت رمز جدید"}
                </button>
                <div className="text-center mt-2">
                  <button
                    className="btn text-primary text-center ms-2 fw-bold "
                    style={{ cursor: "pointer", fontSize: "14px" }}
                    onClick={() =>
                      resendForgetPassword(
                        location && location.state && location.state.mobile
                      )
                    }
                    disabled={timecode > 1 || state.forgetPass}
                  >
                    {state.forgetPass
                      ? "در حال ارسال"
                      : `ارسال مجدد کد تایید : ${fancyTimeFormat(timecode)}`}
                  </button>
                </div>

                <p className="text-center">
                  <Link
                    to={"/"}
                    className="text-primary ms-2 fw-bold "
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    صفحه اصلی
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ForgetPassword;
